export default __webpack_public_path__ + "static/Dashboard-1-7b0a130dc30679cad06283bf5d43eb84.svg";